export const ProductSearchPageSize = 24;